import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db } from './firebase';

export interface SiteSettings {
  siteName?: string;
  welcomeMessage?: string;
  maintenanceMode?: boolean;
  [key: string]: unknown;
}

const SETTINGS_DOC = doc(db, 'settings', 'site');
const CACHE_TTL = 5 * 60 * 1000;

let cache: SiteSettings | null = null;
let cacheTs = 0;

export async function getSiteSettings(): Promise<SiteSettings> {
  if (cache && (Date.now() - cacheTs) < CACHE_TTL) return cache;
  const snap = await getDoc(SETTINGS_DOC);
  cache = snap.exists() ? (snap.data() as SiteSettings) : {};
  cacheTs = Date.now();
  return cache;
}

export async function updateSiteSettings(updates: Partial<SiteSettings>): Promise<void> {
  await setDoc(SETTINGS_DOC, updates, { merge: true });
  cache = null;
  cacheTs = 0;
}

export function clearSettingsCache(): void {
  cache = null;
  cacheTs = 0;
}
